import React, { useMemo } from "react";
import { CalendarDays, CheckCircle2, ChevronRight, ShieldCheck } from "lucide-react";

const numericPrice = (option) => {
  const value = Number(option?.sellingPrice ?? option?.displayPrice);
  return Number.isFinite(value) && value >= 0 ? value : null;
};

const BookingPanel = ({ listing, selectedSku, preSettlementResult }) => {
  const fromPrice = useMemo(() => {
    const prices = (listing?.packages || [])
      .flatMap((group) => group.skus || [])
      .flatMap((sku) => sku.options || [])
      .map(numericPrice)
      .filter((price) => price !== null);
    return prices.length ? Math.min(...prices) : null;
  }, [listing]);

  const scrollToOptions = () => {
    document.getElementById("package-options")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <aside className="things-booking-panel things-section-card">
      <p className="things-booking-panel__eyebrow">Book this experience</p>
      <h2>{selectedSku?.title || "Choose your preferred option"}</h2>
      <div className="things-booking-panel__price">
        <span>{preSettlementResult ? "Current total" : "From"}</span>
        <strong>
          {preSettlementResult?.displayTotalPrice ||
            (fromPrice !== null ? `${listing.currency || "USD"} ${fromPrice.toFixed(2)}` : "Select options")}
        </strong>
      </div>
      <ul>
        <li><CalendarDays aria-hidden="true" /> Select an available date and time</li>
        <li><CheckCircle2 aria-hidden="true" /> Choose the package and traveller quantities</li>
        <li><ShieldCheck aria-hidden="true" /> Availability is checked before payment</li>
      </ul>
      <button type="button" className="things-add-cart-btn" onClick={scrollToOptions}>
        Select options <ChevronRight aria-hidden="true" />
      </button>
    </aside>
  );
};

export default BookingPanel;
